<template>
  <div
    v-if="!loading && !error && carouselCards.length > 0"
    class="mb-2"
    :class="{ 'recently-viewed-compact': compact }"
  >
    <h4 class="mb-1">
      {{ isCurrent === 'true' ? 'Recently Viewed' : 'Recently Viewed' }}
    </h4>
    <swiper
      :options="swiperOptions"
      class="swiper-container"
    >
      <swiper-slide
        v-for="(card, index) in carouselCards"
        :key="index"
      >
        <b-card
          class="mb-0 py-0 carousel-card-clickable"
          @click="navigateToReport(card.reportnumber)"
        >
          <img
            :src="`${baseURL}/servethumbnail.cfm?id=${card.detailsId}`"
            class="card-img-top"
            alt="Product thumbnail"
          >
          <b-card-body class="mb-0">
            <b-card-title class="mb-0">Report {{ card.reportnumber }}</b-card-title>
            <b-card-text class="mb-1">
              {{ card.provider }}
            </b-card-text>
          </b-card-body>
        </b-card>
      </swiper-slide>
      <div
        slot="button-prev"
        class="swiper-button-prev"
      />
      <div
        slot="button-next"
        class="swiper-button-next"
      />
    </swiper>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  props: {
    isCurrent: {
      type: String,
      default: 'false',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BCard,
    BCardBody,
    BCardTitle,
    BCardText,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BACKEND_PATH,
      swiperOptions: {
        slidesPerView: this.compact ? 12 : 7,
        spaceBetween: this.compact ? 8 : 12,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: {
            slidesPerView: this.compact ? 3 : 2,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: this.compact ? 6 : 3,
            spaceBetween: this.compact ? 8 : 10,
          },
          1024: {
            slidesPerView: this.compact ? 9 : 5,
            spaceBetween: this.compact ? 8 : 12,
          },
          1440: {
            slidesPerView: this.compact ? 12 : 7,
            spaceBetween: this.compact ? 8 : 12,
          },
        },
      },
      carouselCards: [],
      loading: false,
      error: false,
    }
  },
  mounted() {
    this.loadRecentlyViewedReports()
  },
  activated() {
    this.loadRecentlyViewedReports()
  },
  methods: {
    loadRecentlyViewedReports() {
      this.loading = true
      this.error = false
      this.$http
        .get('productfilter.cfc?method=GetRecentlyViewedReports', {
          params: {
            isCurrent: this.isCurrent,
          },
        })
        .then(response => {
          this.carouselCards = response.data
          this.loading = false
        })
        .catch(() => {
          this.error = true
          this.loading = false
        })
    },
    navigateToReport(reportNumber) {
      this.$router.push({
        name: 'product-report',
        params: {
          reportNumber,
        },
      })
    },
  },
}
</script>

<style scoped>
/* Swiper styles */
.swiper-container {
  position: relative;
  padding: 0 50px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #1a73e8;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 24px;
  font-weight: bold;
}

.swiper-slide {
  height: auto;
  padding: 0;
}

.swiper-slide .card {
  height: 100%;
}

.swiper-slide .card-body {
  padding: 1rem 0.5rem 0.25rem 0.5rem;
  text-align: center;
}

.swiper-slide .card-title {
  font-size: 1.1rem;
  margin-bottom: 0.35rem !important;
  margin-top: 0.2rem !important;
}

.swiper-slide .card-text {
  font-size: 0.75rem;
  margin-bottom: 0.25rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.swiper-slide .card-img-top {
  width: 100%;
  height: 100px;
  object-fit: contain;
  border-top-left-radius: 0.357rem;
  border-top-right-radius: 0.357rem;
}

.carousel-card-clickable {
  cursor: pointer;
  transition: background-color 0.1s ease, transform 0.2s ease;
}

.carousel-card-clickable:hover {
  transform: translateY(-4px);
  background-color: rgba(26, 115, 232, 0.1);
}

.dark-layout .carousel-card-clickable:hover {
  transform: translateY(-4px);
  background-color: #242B3D;
}

.recently-viewed-compact {
  margin-bottom: 1rem !important;
}

.recently-viewed-compact h4 {
  font-size: 1rem;
  margin-bottom: 0.5rem !important;
}

.recently-viewed-compact .swiper-container {
  padding: 0 32px;
}

.recently-viewed-compact .swiper-button-next:after,
.recently-viewed-compact .swiper-button-prev:after {
  font-size: 18px;
}

.recently-viewed-compact .swiper-slide .card-body {
  padding: 0.45rem 0.25rem 0.15rem 0.25rem;
}

.recently-viewed-compact .swiper-slide .card-title {
  font-size: 0.75rem;
  margin-top: 0.1rem !important;
  margin-bottom: 0.15rem !important;
}

.recently-viewed-compact .swiper-slide .card-text {
  font-size: 0.62rem;
  margin-bottom: 0.1rem !important;
}

.recently-viewed-compact .swiper-slide .card-img-top {
  height: 50px;
}

.recently-viewed-compact .carousel-card-clickable:hover,
.dark-layout .recently-viewed-compact .carousel-card-clickable:hover {
  transform: translateY(-2px);
}
</style>
